<div class="about-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-image">
                    <img src="assets/img/about/about1.jpg" class="shadow" alt="image">
                    <img src="assets/img/about/about2.jpg" class="shadow" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="about-content">
                    <span class="sub-title">Covid-19</span>
                    <h2>CE TREBUIE SĂ ȘTIȚI DESPRE NOUL CORONAVIRUS</h2>
                    <h6>10 elemente comportamentale care trebuiesc urmate:</h6>

                    <ol>
                        <li>Spălați-vă mâinile de multe ori;</li>
                        <li>
                            Evitați contactul cu persoane care sunt suspecte de infecții respiratorii acute;
                        </li>
                        <li>Nu vă atingeți ochii , nasul si gura cu mâinile;
                        </li>
                        <li>Acoperiți-vă gura și nasul daca stranutați sau tușiți;
                        </li>
                        <li>Nu luați medicamente antivirale si nici antibiotice decât în cazul în care va prescrie
                            medicul;
                        </li>
                        <li>Curățați toate suprafețele cu dezinfectanți pe bază de clor sau alcool;
                        </li>
                        <li>Utilizați masca de protecție doar în cazul in care suspectați că sunteți bolnav sau în
                            cazul în care acordați asistență persoanelor bolnave;
                        </li>
                        <li>Produsele ”MADE in CHINA” sau pachetele primite din China nu sunt periculoase;
                        </li>
                        <li>Sunați la 112 dacă aveți febră, tușiți sau v-ați întors din China sau zonele in
                            carantina din Europa de cel puțin 14 zile;
                        </li>
                        <li>Animalele de companie nu transmit coronavirus.
                        </li>
                    </ol>

                    <a routerLink="/coronavirus" class="default-btn"><i
                            class='bx bx-move-horizontal icon-arrow before'></i><span class="label">Vezi
                            detalii</span><i class="bx bx-move-horizontal icon-arrow after"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>